// Nuevo Services.jsx con todos los servicios ajustados
import React from "react";
import { Card, Row, Col, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import postImg from "../assets/images/tratpost.jpeg";
import limpiezaImg from "../assets/images/limpfac.jpeg";
import moldeoImg from "../assets/images/postquirurgicos.jpg";
import reduccionImg from "../assets/images/redcmed.jpeg";
import celulitisImg from "../assets/images/elimcelu.jpeg";
import rejuveneceImg from "../assets/images/rejuv.jpeg";
import manchasImg from "../assets/images/elimanch.jpeg";
import masajesImg from "../assets/images/masrela.jpeg";

const services = [
  {
    key: "moldeo",
    title: "Moldeo Corporal",
    text: "Combina aparatología y técnicas manuales para modelar tu figura.",
    image: moldeoImg,
  },
  {
    key: "reduccion",
    title: "Reducción de Medidas",
    text: "Tratamientos para eliminar grasa localizada y redefinir contorno corporal.",
    image: reduccionImg,
  },
  {
    key: "celulitis",
    title: "Eliminación de Celulitis",
    text: "Técnicas avanzadas que suavizan la piel y mejoran la circulación.",
    image: celulitisImg,
  },
  {
    key: "postquirurgicos",
    title: "Post-Quirúrgicos",
    text: "Recupérate con masajes, ultrasonido y seguimiento profesional tras tu cirugía.",
    image: postImg,
  },
  {
    key: "limpieza",
    title: "Limpieza Facial",
    text: "Purifica y equilibra tu rostro eliminando impurezas y toxinas.",
    image: limpiezaImg,
  },
  {
    key: "rejuvenece",
    title: "Rejuvenecimiento Facial",
    text: "Devuelve firmeza y frescura a tu piel con técnicas regenerativas.",
    image: rejuveneceImg,
  },
  {
    key: "manchas",
    title: "Eliminación de Manchas",
    text: "Tratamientos despigmentantes para unificar el tono y devolver luminosidad.",
    image: manchasImg,
  },
  {
    key: "masajes",
    title: "Masajes Relajantes",
    text: "Técnicas suaves que reducen el estrés y mejoran tu bienestar físico y mental.",
    image: masajesImg,
  },
];

export default function Services() {
  const navigate = useNavigate();

  return (
    <section id="services" className="py-5 fade-in">
      <Container
        style={{ background: "#f8ffff", borderRadius: 12, padding: 20 }}
      >
        <h2 className="text-center mb-5" style={{ color: "#056d7a" }}>
          Nuestros Servicios
        </h2>
        <Row>
          {services.map((svc) => (
            <Col md={6} lg={3} key={svc.key} className="mb-4">
              <Card
                className="h-100 shadow-sm overflow-hidden"
                onClick={() => navigate(`/servicios/${svc.key}`)}
                style={{
                  cursor: "pointer",
                  background:
                    "linear-gradient(135deg, #ffffff 0%, #e0fbfc 100%)",
                  transition: "transform 0.3s, box-shadow 0.3s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "scale(1.03)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                <Card.Img
                  variant="top"
                  src={svc.image}
                  style={{ height: 180, objectFit: "cover" }}
                />
                <Card.Body className="text-center">
                  <Card.Title style={{ color: "#056d7a" }}>
                    {svc.title}
                  </Card.Title>
                  <Card.Text className="text-muted">{svc.text}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}
